import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { DashboardPage } from "./pages/DashboardPage";
import { MeetingRoomPage } from "./pages/MeetingRoomPage";
import { JoinGuestPage } from "./pages/JoinGuestPage";

export default function App() {
  return (
    <AuthProvider>
      <ErrorBoundary label="Application error">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/room/:meetingId"
            element={
              <ErrorBoundary label="Meeting room error">
                <MeetingRoomPage />
              </ErrorBoundary>
            }
          />
          <Route path="/join/:token" element={<JoinGuestPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ErrorBoundary>
    </AuthProvider>
  );
}
